module.exports = __webpack_public_path__ + "media/icons/pochodzenie@3x-7533b298.svg";